<template>
  <div class="help">
    <div class="header">
      <header>
        <img src="~assets/images/game/return.png" alt @click="returnpage" />
        <span>常见问题</span>
      </header>
      <ul class="box" ref="box">
        <li>
          <div @click="goIt(0)">
            <img src="~assets/images/xinshou.png" alt="新手问题" />提现问题
          </div>
        </li>
        <li>
          <div @click="goIt(1)">
            <img src="~assets/images/yingyong.png" alt="应用问题" />收徒问题
          </div>
        </li>
        <li>
          <div @click="goIt(2)">
            <img src="~assets/images/zhanghao.png" alt="账号问题" />应用问题
          </div>
        </li>
        <li>
          <div @click="goIt(3)">
            <img src="~assets/images/shouyi.png" alt="收成问题" />挑战问题
          </div>
        </li>
        <li>
          <div @click="goIt(4)">
            <img src="~assets/images/chengjiu.png" alt="生涯问题" />口令问题
          </div>
        </li>
        <li>
          <div @click="goIt(5)">
            <img src="~assets/images/haoyou.png" alt="好友问题" />活动问题
          </div>
        </li>
      </ul>
    </div>
    <ul class="problem" ref="problem">
      <li>
        <h3>提现问题</h3>
        <ul class="list">
          <li>
            <div @click="isShow">
              1.我的提现被拒绝的原因是什么？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              我们一般不会拒绝用户的提现，如果您的提现被拒绝，有可能是如下情况
              a.你提现填写的名字和微信实名认证名字不一致。
              b.您的提现微信未进行实名认证
              请进行微信实名认证，并填写与微信实名认证的姓名一致的真实姓名
            </p>
          </li>
          <li>
            <div @click="isShow">
              2.怎么查询微信的实名认证？
              <i class="jiantou"></i>
            </div>
            <p>请打开微信，依次点击：我 - 钱包 - 右上角“四个小框” - 支付管理 - 实名认证，就可以查看微信实名状态啦~</p>
          </li>
          <li>
            <div @click="isShow">
              3.怎么查询支付宝的实名认证？
              <i class="jiantou"></i>
            </div>
            <p>请打开支付宝，依次点击：我的-上方点击名称-身份认证，即可查看支付宝实名状态</p>
          </li>
          <li>
            <div @click="isShow">
              4.提现没有到账是为什么？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              小额提现一般在1-3个工作日内到账，请耐心等待
              大额提现（50元以上），防止非法人员恶意盗取奖励，保证正常玩家的核心利益，我们会特殊审核，请注意提现说明。
            </p>
          </li>
          <li>
            <div @click="isShow">
              5.提现失败会返还吗？
              <i class="jiantou"></i>
            </div>
            <p>如果提现失败，提现机会及现金均会返还！但是需要您重新填写信息，确保提现成功</p>
          </li>
          <li>
            <div @click="isShow">
              6.为什么我提现不了？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              提现要满足对应条件
              a.绑定微信及手机号码（【账号管理】及提现界面均需绑定正确）
              b.提供和绑定微信实名认证一致的真实姓名
              c.连续游戏的提现，需要连续打开APP十天，每天游戏超过10分钟
            </p>
          </li>
          <li>
            <div @click="isShow">
              7.我要如何才能进行提现？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              a.打开【我的】模块。
              b.点击右上角头像下方【总金额】选项，即可进行提现操作。
              c.赚取足够额度后即可多次进行提现
              d.目前仅可以提现到微信账户中
            </p>
          </li>
          <li>
            <div @click="isShow">
              8.金币、现金过期会被清零？
              <i class="jiantou"></i>
            </div>
            <p
              style="white-space:pre-wrap"
            >如果用户连续30天及以上未登录233小游戏手机客户端，那么此前发放的金币、现金奖励将过期，系统会在奖励到期前发送提醒。逾期未登录233小游戏手机客户端的，视为用户自愿放弃相关奖励，账户金额将被清零。</p>
          </li>
          <li>
            <div @click="isShow">
              9.用户从233提现所得，需要交税吗？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">根据国家税务要求，233小游戏会对提现成功的用户进行个税申报。</p>
          </li>
          <li>
            <div @click="isShow">
              10.连续游戏的提现要求是什么？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              a.连续登陆10天
              b.连续登陆的每天中游戏时间超过10分钟（建议多玩一会，系统时间可能会有误差）
              c.如果以上两个条件未达到，会导致中断，需要从第一天开始重新计算
              d.连续游戏提现，可以持续完成，每10天完成1次，收益非常丰厚哦
            </p>
          </li>
        </ul>
      </li>

      <li>
        <h3>收徒问题</h3>
        <ul class="list">
          <li>
            <div @click="isShow">
              1.为什么填写邀请码不是徒弟？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              徒弟需要满足以下要满足的条件
              a.徒弟第一次下载233小游戏
              b.徒弟打开你发的邀请链接并下载233小游戏
              c.填写你给徒弟的红包口令（邀请的一天内有效）；若红包口令填写不了，可让徒弟随便玩一款233游戏，即可填写。
              d.徒弟绑定微信即可成为有效徒弟，开始给你进贡
            </p>
          </li>
          <li>
            <div @click="isShow">
              2.收徒红包何时到账？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              收徒红包一共5个红包，每个1元）
              1.收徒第一天，徒弟绑定微信，即可获得1个红包，自动发放到你的现金余额里。
              2.收徒第2-5天，徒弟该天玩10分钟233小游戏，该天得1个红包，4天共4个红包，自动发放到你的现金余额里。
            </p>
          </li>
          <li>
            <div @click="isShow">
              3.唤醒徒弟不成功
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              唤醒规则： 除刚邀请的初始5天，需要徒弟3天以上不登录才能唤醒他，“提醒ta”按钮状态为亮。
              a.师傅需要点击“提醒ta”按钮，并发送链接给徒弟。
              b.该徒弟需点击链接打开233（可用浏览器打开链接）。
              c.玩十分钟233游戏才算唤醒成功。
              唤醒的奖励可在现金明细里查看。
            </p>
          </li>
          <li>
            <div @click="isShow">
              4.徒弟的红包口令输不了怎么办？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              a.如果徒弟下载登录233小游戏超过1天，口令自动失效
              b.可能是徒弟拒绝过某些权限，请让他试玩任意一款游戏，再输入口令红包
            </p>
          </li>
        </ul>
      </li>

      <!-- 应用问题 -->
      <li>
        <h3>应用问题</h3>
        <ul class="list">
          <li>
            <div @click="isShow">
              1.如何清除我不想玩的游戏？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              a.打开233，在底栏打开【我的】
              b.打开【清理缓存】，选择不玩的游戏清除就可以了
            </p>
          </li>
          <li>
            <div @click="isShow">
              2.我要如何切换账号？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              a.请先卸载233小游戏
              b.重新安装233小游戏即可重新登录
            </p>
          </li>
          <li>
            <div @click="isShow">
              3.为什么我玩游戏没有获得金币？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              a.请查看233小游戏版本是否为新版
              b.请保证游戏时间超过1分钟，通过游戏内悬浮球返回到233，便可以获得收益
              c.关闭APP后再次进入233，也可以获得上次玩游戏获得的金币收益
            </p>
          </li>
          <li>
            <div @click="isShow">
              4.如何更新APP？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              a.在【我的】模块中点击“检查更新”
              b.若有新的版本会弹出更新页面，选择“立即更新”
              c.更新过程中需要一些时间，请您稍作等待。
              d.若点击“立即更新”无法应，可以多次点击按钮尝试
              e.更新完成后，会提示安装，安装成功即可
              e.若无新的版本会提示：你已经是最新版本了
            </p>
          </li>
        </ul>
      </li>

      <!-- 账号问题 -->
      <li>
        <h3>挑战问题</h3>
        <ul class="list">
          <li>
            <div @click="isShow">
              1.为什么我的分数没有上传成功？
              <i class="jiantou"></i>
            </div>
            <p>确保网络环境良好的情况下，进入游戏，保证游戏过程中全程联网，等到游戏的结算分数出来后，便可以正确上传分数</p>
          </li>
          <li>
            <div @click="isShow">
              2.排行榜奖励怎么没有发放？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              1.排行榜奖励每周四12点发放
              2.奖励需要手动领取，请在挑战页面处的领取赏金进行领取
            </p>
          </li>
          <li>
            <div @click="isShow">
              3.游戏加载不出来怎么办？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              a.请您尝试退出APP，重新进入后打开游戏
              b.若是新下载的游戏，可以在【我的游戏】中左滑，选择移除。（若是您已经玩过的游戏，建议不要进行次操作，会删除您的存档）
              c.更新APP版本，在【我的】模块中点击“检查更新”
            </p>
          </li>
        </ul>
      </li>

      <!-- 收成问题 -->
      <li>
        <h3>口令问题</h3>
        <ul class="list">
          <li>
            <div @click="isShow">
              1.如何获取口令红包?
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              请在【微信】中关注微信公众号【233游戏平台】发送【口令红包】即可获取今日的口令
              微信口令每天上午11点准时更新，当日有效。数量有限，先到先得！
              更多渠道的口令获取方式，请关注233的活动通知
            </p>
          </li>
          <li>
            <div @click="isShow">
              2.如何使用口令红包?
              <i class="jiantou"></i>
            </div>
            <p>打开233小游戏进入【我的】——【口令红包】输入对应口令即可领取红包。</p>
          </li>
        </ul>
      </li>

      <!-- 成就问题 -->
      <li>
        <h3>活动问题</h3>
        <ul class="list">
          <li>
            <div @click="isShow">
              1.为什么我的支付宝8元领取不了？
              <i class="jiantou"></i>
            </div>
            <p style="white-space:pre-wrap">
              参与支付宝8元红包需要满足一定条件：
              a.未开通过支付宝的账号
              b.通过页面注册领取8元支付宝红包
            </p>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { goBack } from "@/utils/base";
export default {
  name: "help",
  data() {
    return {
      increment: ""
    };
  },
  methods: {
    returnpage() {
        console.log(111)
      goBack();
    },
    goIt(num) {
      let el = this.$refs.problem.children[num],
        topHeight = this.$refs.box.clientHeight;
      let time = 200,
        _this = this;
      let toScroll = el.offsetTop - topHeight,
        nowScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
      let increment = (toScroll - nowScroll) / (time / 10);
      clearInterval(this.timero);
      if (increment >= 0) {
        this.timero = setInterval(function() {
          nowScroll += increment;
          window.scrollTo(0, nowScroll);
          if (nowScroll + increment >= toScroll) {
            // 关闭定时器
            clearInterval(_this.timero);
            // 把元素高度值还原
            window.scrollTo(0, toScroll);
          }
        }, 10);
      } else {
        this.timero = setInterval(function() {
          nowScroll += increment;
          window.scrollTo(0, nowScroll);
          if (nowScroll + increment <= toScroll) {
            // 关闭定时器
            clearInterval(_this.timero);
            // 把元素高度值还原
            window.scrollTo(0, toScroll);
          }
        }, 10);
      }

      //   console.log();
      //   window.scrollTo(0,);

      //console.log(el.offsetTop,topHeight)
    },
    isShow() {
      let nowLi = event.currentTarget.parentNode;
      if (nowLi.isShow) {
        nowLi.isShow = false;
        nowLi.className = "";
      } else {
        nowLi.isShow = true;
        nowLi.className = "active";
      }
      // console.log(nowLi.isShow);
      this.scorll(nowLi);
    },
    scorll(e) {
      let time = 200,
        el = e.getElementsByTagName("p")[0];
      if (e.isShow) {
        if (el.offsetHeight == 0) {
          //如果当前高度为0，则执行下拉动画
          // 获取元素总高度
          el.style.display = "block"; // 1.显示元素，元素变为可见
          if (!el.isHeight) {
            el.isHeight = el.offsetHeight; // 2.保存总高度
          }
          // else{
          //     var totalHeight = this.height[cardshow];
          // }
          el.style.height = "0px"; // 3.再将元素高度设置为0，元素又变为不可见
          // 定义一个变量保存元素当前高度
          var currentHeight = 0; // 当前元素高度为0
          // 计算每次增加的值
          var increment = el.isHeight / (time / 10);
          // 开始循环定时器
          var timer = setInterval(function() {
            // 增加一部分高度
            currentHeight = currentHeight + increment;
            // 把当前高度赋值给height属性
            el.style.height = currentHeight + "px";
            // 如果当前高度大于或等于总高度则关闭定时器
            if (currentHeight >= el.isHeight) {
              // 关闭定时器
              clearInterval(timer);
            }
          }, 10);
        }
      } else {
        if (el.offsetHeight > 0) {
          // 如果当前高度不为0，则执行上滑动画
          // 获取元素总高度
          if (!el.isHeight) {
            el.isHeight = el.offsetHeight; // 2.保存总高度
          }
          //el.isHeight = el.offsetHeight;
          // console.log(totalHeight)
          // 定义一个变量保存元素当前高度
          var currentHeight = el.isHeight;
          // 计算每次减去的值
          var decrement = el.isHeight / (time / 10);
          // 开始循环定时器
          var timer = setInterval(function() {
            // 减去当前高度的一部分
            currentHeight = currentHeight - decrement;
            // 把当前高度赋值给height属性
            el.style.height = currentHeight + "px";
            // 如果当前高度小于等于0，就关闭定时器
            if (currentHeight <= 0) {
              // 关闭定时器
              clearInterval(timer);
              // 把元素display设置为none
              el.style.display = "none";
              // 把元素高度值还原
              el.style.height = el.isHeight + "px";
            }
          }, 10);
        }
      }
    }
  }
};
</script>

<style lang='less' scoped>
.header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 10;
}
header {
  height: 0.5rem;
  display: flex;
  justify-items: center;
  > :nth-child(1) {
    width: 0.25rem;
    height: 0.25rem;
    z-index: 11;
    margin: auto 0.05rem;
  }
  > :nth-child(2) {
    width: 100%;
    margin-left: -0.25rem;
    text-align: center;
    line-height: 0.5rem;
    font-size: 0.19rem;
    font-weight: 400;
    color: rgba(27, 27, 27, 1);
    display: inline-block;
  }
}
.box {
  font-size: 0;
  padding: 0.057rem;
  text-align: center;
}
.box > li {
  display: inline-block;
  width: 33.3%;
  padding: 0.04688rem;
  box-sizing: border-box;
}
.box > li > div {
  background-color: #f9f9f9;
  border-radius: 0.04rem;
  height: 0.416rem;
  font-size: 0.156rem;
  line-height: 0.416rem;
  position: relative;
}
.box > li > div:active:before {
  width: 100%;
  height: 100%;
  content: "";
  background-color: rgba(0, 0, 0, 0.3);
  position: absolute;
  border-radius: 0.04rem;
  top: 0;
  left: 0;
}
.box div > img {
  height: 0.125rem;
  width: 0.125rem;
  vertical-align: middle;
  margin-right: 0.05rem;
}
.problem {
  padding-top: 1.135rem;
}
.problem > li > h3 {
  margin: 0;
  text-align: left;
  padding-left: 0.104rem;
  font-size: 0.177rem;
  color: #333;
  background-color: #f8f8f8;
  height: 0.52rem;
  line-height: 0.52rem;
}
.list div {
  text-align: left;
  height: 0.52rem;
  line-height: 0.52rem;
  color: #666666;
  font-size: 0.156rem;
  box-shadow: inset 0 -1px 0 0 #f8f8f8;
  padding: 0 0.3rem 0 0.156rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
}
.jiantou {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background-image: url(~assets/images/jiantou.png);
  background-size: 100%;
  position: absolute;
  top: 0.208rem;
  right: 0.12rem;
  transition: transform 0.2s;
}
.list p {
  text-align: left;
  font-size: 0.145rem;
  color: #999999;
  line-height: 0.291rem;
  padding: 0.052rem 0.135rem 0.052rem 0.166rem;
  box-shadow: inset 0 -1px 0 0 #f8f8f8;
  display: none;
  overflow: hidden;
}
.list .active div {
  color: #333;
}
.list .active div > i {
  transform: rotate(-180deg);
}
</style>
